import { Link, useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import { useAuth } from '../lib/auth';
import { initialsFor } from '../lib/types';

/** Firebase provider ids, as something a person would recognise. */
function signInMethod(providerIds: string[]): string {
  const names = providerIds.map((id) => {
    if (id === 'google.com') return 'Google';
    if (id === 'password') return 'Email and password';
    if (id === 'apple.com') return 'Apple';
    return id;
  });
  return names.length ? names.join(', ') : 'Unknown';
}

export default function Account() {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  const name = [profile?.firstName, profile?.lastName].filter(Boolean).join(' ');

  return (
    <>
      <AppHeader title="Account" />

      <main>
        <section className="group">
          <h2 className="field-label">Profile</h2>
          <Link className="row link" to="/profile">
            <span className="avatar">{initialsFor(profile, user?.displayName, user?.email)}</span>
            <span className="row-main">
              <span>{name || user?.displayName || 'Add your name'}</span>
              <span className="muted small">{user?.email}</span>
            </span>
            <span className="muted" aria-hidden="true">›</span>
          </Link>
        </section>

        <section className="group">
          <h2 className="field-label">Subscription</h2>
          {/* Naming the plan is safe here, where it once was not. The web had no way to read
              entitlement — it comes from the RevenueCat SDK on the device — so this said
              nothing rather than risk showing "Free" to a subscriber. The `getEntitlement`
              callable now answers server-side, and reaching this screen at all means the
              answer was Pro: App.tsx renders the upgrade screen otherwise. Billing itself is
              still the phone's, because that is where the purchase lives. */}
          <div className="row">
            <span className="row-main">
              <span>Pro</span>
              <span className="muted small">
                The web app is a Pro feature. Billing is managed in the iOS app.
              </span>
            </span>
          </div>
        </section>

        <section className="group">
          <h2 className="field-label">Authentication</h2>
          <div className="row">
            <span className="row-main"><span>Sign-in method</span></span>
            <span className="muted">{signInMethod(user?.providerData.map((p) => p.providerId) ?? [])}</span>
          </div>
          <div className="row">
            <span className="row-main"><span>Email</span></span>
            <span className="muted">{user?.email ?? '—'}</span>
          </div>
        </section>

        <section className="group">
          <h2 className="field-label">App information</h2>
          <div className="row">
            <span className="row-main"><span>Version</span></span>
            <span className="muted">{__APP_VERSION__}</span>
          </div>
          <div className="row">
            <span className="row-main"><span>Capture</span></span>
            <span className="muted">iOS and Android</span>
          </div>
        </section>

        <div className="actions">
          <button
            type="button"
            className="danger"
            onClick={() => {
              navigate('/');
              void signOut();
            }}
          >
            Sign out
          </button>
        </div>
      </main>
    </>
  );
}
